import React from "react";
import AntdCheckbox from "antd/lib/checkbox/Checkbox";
import { ThemeConfigKeys } from "../../utils/Constants";
import { ThemeProvider } from "../../layout/ThemeProvider";

const Checkbox = ({ children, className, isSecondary, ...props }: any) => {
  return (
    <ThemeProvider themeKey={ThemeConfigKeys.DefaultThemeSecondary}>
      <AntdCheckbox {...props}>{children}</AntdCheckbox>
    </ThemeProvider>
  );
};

export default Checkbox;
